<template>
    <div class="tagsets-grabber-page" v-if="hashtagCollectorOpened">
        <div class="container">
            <b-btn-close @click="closeHashtagCollector"></b-btn-close>
            <HashtagInput
                    :suggestedHashtags="getBookmarkedHashtags"
                    :save=true
                    :compare=true
                    :copy=true
                    :clear="true"
                    @clear="setResetBookmark"
                    @added="setBookmarkHashtag"/>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import HashtagInput from './HashtagInput';

    export default {
        name: "HashtagCollector",
        components: {
            HashtagInput
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            ...mapActions('comparison', [
                'setBookmarkHashtag',
                // 'removeBookmarkHashtag', todo
                'setResetBookmark',
                'closeHashtagCollector'
            ])
        },
        computed: {
            ...mapGetters('comparison', [
                'getBookmarkedHashtags'
            ]),
            ...mapState('comparison', ['hashtagCollectorOpened'])
        }
    };
</script>

<style lang="scss">
    .tagsets-grabber-page {
        position: fixed;
        bottom: 0;
        z-index: 999;
        padding: 2px 0;
        width: 100%;

        .container {
            margin-right: auto;
            margin-left: auto;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: white;
            border-top: #c12f93 2px solid;
            border-left: #c12f93 2px solid;
            border-right: #c12f93 2px solid;
            border-top-left-radius: 11px;
            border-top-right-radius: 11px;
            box-shadow: 1px -1px 7px 3px #8080804d;

            button.close {
                margin-left: 10px;
            }
        }

    }
</style>
